import Microgame from '../engine/Microgame.js';

export default class DontMoveGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: 'Don\'t Move !', en: 'Don\'t Move!', es: '¡No te muevas!' },
            controls: { fr: 'Ne touche à rien', en: 'Don\'t touch anything', es: 'No toques nada' },
            objective: { fr: 'Lâche ton écran ou ta souris jusqu\'à la fin du temps', en: 'Let go of your screen or mouse until the time is up', es: 'Suelta tu pantalla o ratón hasta que termine el tiempo' },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 20.5V8.5a2 2 0 0 1 4 0v5h.5a2.5 2.5 0 1 1 5 0V17"></path><path d="M14 8.5V5a2 2 0 1 0-4 0v3.5"></path><path d="M10 8.5V4a2 2 0 0 0-4 0v4.5"></path><path d="M6 8.5V6a2 2 0 0 0-4 0v11.17c0 2.25 1.5 4.3 3.65 4.7l4.35.83"></path><line x1="2" y1="2" x2="22" y2="22"></line></svg>`,
            actions: [
                { type: 'wait', duration: 2200 },
            ],
            loopDuration: 2600
        };
    }
    constructor(engine) {
        super(engine);
        this.threshold = 10; // pixels
        this.startPos = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "DON'T MOVE!";

        // Visual indicator
        // Visual indicator (Neon No Entry)
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 200;
        canvas.style.position = 'absolute';
        canvas.style.top = '50%';
        canvas.style.left = '50%';
        canvas.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(canvas);

        const ctx = canvas.getContext('2d');
        const cx = canvas.width / 2;
        const cy = canvas.height / 2;
        const r = 80;

        // Randomly choose Primary or Secondary
        const color = Math.random() > 0.5 ? this.primaryColor : this.secondaryColor;

        // Glow
        ctx.shadowBlur = 20;
        ctx.shadowColor = color;
        ctx.strokeStyle = color;
        ctx.lineWidth = 15;

        // Circle
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.stroke();

        // Slash
        ctx.beginPath();
        ctx.moveTo(cx + r * Math.cos(Math.PI / 4), cy - r * Math.sin(Math.PI / 4)); // Top Right (approx)
        ctx.lineTo(cx - r * Math.cos(Math.PI / 4), cy + r * Math.sin(Math.PI / 4)); // Bottom Left
        ctx.stroke();

        // We need to track movement. 
        // Our InputHandler emits 'swipe' on end, but we need real-time checking or check on end.
        // "Don't Move" usually means "Don't shake the device" or "Don't move the mouse".
        // For touch, it might mean "Don't lift finger" or "Don't touch screen"?
        // Let's interpret it as: If you are touching, don't move. If you aren't, don't touch.
        // Or simpler: Just don't interact.

        // Let's go with: If any input is detected (tap or swipe or movement), you lose.
        // But InputHandler only emits processed events.
        // We might need to listen to raw events or add a 'move' event to InputHandler.

        // Let's add a 'move' listener to InputHandler or just listen directly here.
        this.onMove = this.onMove.bind(this);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerdown', this.onMove);
    }

    onMove(e) {
        if (!this.active) return;
        // If it's just a hover (mouse), it might be annoying to lose immediately.
        // But for "Don't Move", usually it implies "Stop everything".
        // Let's be lenient: Only fail if it's a significant movement or a click.

        if (e.type === 'pointerdown') {
            this.lose();
            return;
        }

        // For pointermove, only if button is pressed (drag) or maybe just any movement?
        // On mobile, pointermove only happens if touching.
        // On desktop, it happens always.
        // Let's fail on any pointerdown.
        // And fail on pointermove ONLY if it's a touch event (or mouse down).

        // Actually, "Don't Move" on mobile usually means "Don't tap".
        // Let's keep it simple: FAIL ON TAP/CLICK.
    }

    update(dt) {
        // Win condition is time running out without failing.
        // The engine handles time out as fail by default?
        // Wait, engine says: if (this.timer <= 0) handleMicrogameResult(false);

        // We need to override this behavior for this specific game.
        // Or, we can just trigger win() right before time runs out?
        // Or better: The game logic should handle the win.

        if (this.engine.timer <= 100) { // Win just before timeout
            this.win();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerdown', this.onMove);
    }
}
